import React, { FC, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { Fansea3DStageTheme } from './Fansea3DStageTheme';
import { EditIcon } from './FanseaIcons';

export enum Fansea3DStageMenuButtonV2Icon {
  Fullscreen,
  Inspector,
  ResetCamera,
}

export interface Fansea3DStageMenuButtonV2Props {
  onClick: MouseEventHandler<HTMLButtonElement>;
  theme: Fansea3DStageTheme;
  isInspectorOpen?: boolean;
}

const StyledButton = styled.button<{ isInspectorOpen: boolean }>`
  border: 0;
  border-radius: 100%;
  padding: 8px;
  background: ${({ isInspectorOpen }) =>
    isInspectorOpen ? 'rgba(0, 0, 0, 0.2)' : 'rgba(8, 232, 222, 0.08)'};
  border: 1px solid rgba(8, 232, 222, 0.2);
  box-shadow: 0px 1px 6px rgba(8, 232, 222, 0.5), inset 0px 0px 20px #08e8de;
  cursor: pointer;
  width: 77px;
  height: 77px;

  &:hover {
    background: rgba(0, 0, 0, 0.2);

    > svg {
      fill: #08e8de;
    }
  }

  > svg {
    width: 50%;
    height: 50%;
    fill: ${({ isInspectorOpen }) => (isInspectorOpen ? '#08E8DE' : 'none')};
    // scale: 0.6;
  }
`;

export const Fansea3DStageMenuButtonV2: FC<Fansea3DStageMenuButtonV2Props> = ({
  onClick,
  // theme,
  isInspectorOpen = false,
}) => {
  return (
    <StyledButton onClick={onClick} isInspectorOpen={isInspectorOpen}>
      <EditIcon />
    </StyledButton>
  );
};
